export default "skymp5-front/f180f0473d1a87f76fb911597f6cfe43.png";